var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{ref:"input",attrs:{"value":_vm.rawValue,"disabled":_vm.disabled,"readonly":_vm.readonly,"size":_vm.size},on:{"input":_vm.input,"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }